import React from 'react';
import { Grid, TextField, Typography, Box } from '@mui/material';

const TimingsSection = ({ formData, handleChange }) => {
  const timingFields = [
    { label: "Wheel In Time", name: "wheel_in_time" },
    { label: "Anesthesia Start Time", name: "anesthesia_start_time" },
    { label: "Incision Time", name: "incision_time" },
    { label: "Closure Time", name: "closure_time" },
    { label: "Anesthesia End Time", name: "anesthesia_end_time" },
    { label: "Wheel Out Time", name: "wheel_out_time" },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 2: Timings
      </Typography>
      <Grid container spacing={2}>
        {timingFields.map((field) => (
          <Grid item xs={12} sm={4} key={field.name}>
            <TextField
              label={field.label}
              type="time"
              fullWidth
              InputLabelProps={{ shrink: true }}
              name={field.name}
              value={formData[field.name] || ''}
              onChange={handleChange}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TimingsSection;
